import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoConciergeinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("circle", {
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round",
			cx: 32,
			cy: 32,
			r: 30
		}), /* @__PURE__ */ _jsx("path", {
			d: "M35 43a3 3 0 0 1-6 0V30a3 3 0 0 1 6 0v13zm-3-19a3 3 0 1 1 0-6 3 3 0 0 1 0 6z",
			fill: "currentColor"
		})]
	})
});
export default SvgInfoConciergeinline;
